// Stub: expo-local-authentication — biometrics not available on web/desktop
// All auth guards that check hasHardwareAsync() will skip biometric flows gracefully.
export const hasHardwareAsync = () => Promise.resolve(false);
export const isEnrolledAsync  = () => Promise.resolve(false);
export const authenticateAsync = () => Promise.resolve({ success: false, error: 'not_available' });
export const supportedAuthenticationTypesAsync = () => Promise.resolve([]);
export const getEnrolledLevelAsync = () => Promise.resolve(0);
export const SecurityLevel = { NONE: 0, SECRET: 1, BIOMETRIC_WEAK: 2, BIOMETRIC_STRONG: 3 };
export const AuthenticationType = { FINGERPRINT: 1, FACIAL_RECOGNITION: 2, IRIS: 3 };
export default {
  hasHardwareAsync, isEnrolledAsync, authenticateAsync,
  supportedAuthenticationTypesAsync, getEnrolledLevelAsync,
  SecurityLevel, AuthenticationType,
};
